export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAAQCAYAAAA8qK60AAAAFklEQVQYV2NkgAJGVMb3W/8hInRmAABTnydx6S48twAAAABJRU5ErkJggg=="